import React from "react";
import "../Page.css";
import "./style.css";
import google_search_logo from "../../Assets/integration/google_search_console.svg"
import gmerchant from "../../Assets/integration/google-merchant.svg";
import KeyValueBox from "./keyValueBox/keyValueBox";
import CodeBox from "./codeBoxComponent/codeBox";

const Google = () => {
 
  return (
    <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" }}>
      <div className="component-card">
        <div className="header_integration">
          <div className="name_header_int">
            
            <div className="int_heading_content">
            <h4>Google Merchant</h4>
              <span className="active_state active">Active</span>
              
            </div>
            
          </div>
          <img className="int_logo" src={gmerchant} />
          
        </div>

        <div className="params_int">
        <KeyValueBox label={"Google Merchant ID"} value={"YOUR_VERIFICATION_CODE_HERE"} />
        <KeyValueBox label={"Google Merchant Feed"} hideContent={false} value={"https://google.sheets.com/jason-merchant-feed"} />
        </div>
      </div>
    </div>
  );
};

export default Google;
